import React from 'react';

import NodeColleagueFull from './Full';
import NodeColleagueTeaser from './Teaser';
import NodeColleagueParagraph from './Paragraph';

const NodeColleague = ({ viewMode, ...props }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeColleagueTeaser {...props} />;

    case 'paragraph':
      return <NodeColleagueParagraph {...props} />;

    default:
      return <NodeColleagueFull {...props} />;
  }
};

export default NodeColleague;
